import React from "react";
import "../CSS/About__me.css";
function About__me() {
  return (
    <div className="about__me__container  pt-[130px] pb-[130px]  md:pl-[70px] md:pr-[70px] pl-2 pr-2">
      <p className="text-center">
        <span className="p-2 about__me__title ">About Me</span>
      </p>
      <h1 className="text-center know__me__title mt-6 " style={{fontSize: 'clamp(2rem,4vw,6rem)'}}>Know Me More!</h1>
      <div>
        <div className="know__me__introduction lg:flex lg:items-center" uk-scrollspy="cls: uk-animation-slide-bottom; target: .uk-card; delay: 300; repeat: true">
          <div className="know__me__introduction__title lg:w-[70%] mt-12 uk-card">
            <h1>
              Hi, I'm <span className="">Ibtisam Akram</span>
            </h1>
            <div className="know__me__introduction__explain">
              <p className="pt-2">
                I'm a designer & developer with a passion for web design. I
                enjoy developing simple, clean and slick websites that provide
                real value to the end user. Thousands of clients have procured
                exceptional results while working with me. Delivering work
                within time and budget which meets client’s requirements is our
                moto.
              </p>
            </div>
          </div>
          <div className="about__me__experience w-full lg:w-[40%] flex flex-col justify-center items-center m-auto text-center uk-animation-shake" uk-scrollspy="cls: uk-animation-shake; target: .uk-card; delay: 300; repeat: true">
            <h1 className="experience__value uk-card">06</h1>
            <h1 className="about__me__experience__title uk-card">
              Months of <span className="">Experience</span>
            </h1>
          </div>
        </div>
        <div className="md:flex md:flex-row md:justify-between mt-14 flex flex-col justify-start md:space-x-0 space-x-1" uk-scrollspy="cls: uk-animation-slide-right; target: .uk-card; delay: 300; repeat: true">
        <div className="uk-card">
            <h1 className="text__gray">Name:</h1>
            <h1 className="bold__text pt-2">Ibtisam Akram</h1>
        </div>
        <div className="uk-card">
            <h1 className="text__gray">Email:</h1>
            <h1 className="bold__text pt-2">ibtisamakram5@gmail.com</h1>
        </div> <div className="uk-card">
            <h1 className="text__gray">Date of birth:</h1>
            <h1 className="bold__text pt-2">14 Octobar, 1999</h1>
        </div> <div className="uk-card">
            <h1 className="text__gray">From:</h1>
            <h1 className="bold__text pt-2">Lahore Cantt, Pakistan</h1>
        </div>
        </div>
      </div>
    </div>
  );
}

export default About__me;
